/* eslint-disable react/no-array-index-key */
import { ChevronRight } from '@components/icons'
import { BreadcrumbType } from '@gql/graphql'
import { A11y, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import JsonLd from '../JsonLd/JsonLd'
import WLink from '../WLink/WLink'
import styles from './Breadcrumbs.module.sass'

interface ItemProps {
  label: string
  url?: string
  first?: boolean
  last?: boolean
  hidden?: boolean
}

interface Props {
  breadcrumbs: BreadcrumbType[]
  variant?: 'dark' | 'light'
  className?: string
}

const BreadcrumbsItem = (props: ItemProps) => {
  const { label = '', url = '', first = false, last = false, hidden = false } = props

  return (
    <div
      className={`${styles.item} ${hidden ? styles['item--hidden'] : ''}`}
      aria-hidden={hidden || undefined}
    >
      {!first && <ChevronRight className={styles.icon} />}
      {last || !url ? (
        <span className={styles.itemLabel}>{label}</span>
      ) : (
        <WLink className={styles.itemLink} href={url}>
          {label}
        </WLink>
      )}
    </div>
  )
}

const Breadcrumbs = (props: Props) => {
  const { breadcrumbs = [], variant = '', className = '' } = props

  const jsonLdItems = breadcrumbs
    .filter((item) => !!item.url && !!item.label)
    .map((item, i) => ({
      position: i + 1,
      name: item.label ? item.label.replace(/"/g, '') : '',
      item: item.url,
    }))

  return (
    <>
      <section className={`${styles.root} ${styles.mobile} ${styles[`root--${variant}`]} ${className}`}>
        <Swiper
          modules={[A11y, FreeMode]}
          slidesPerView="auto"
          spaceBetween={8}
          className={styles.swiper}
          initialSlide={breadcrumbs.length - 1}
          freeMode={{
            enabled: true,
            sticky: true,
            momentumRatio: 0.25,
            minimumVelocity: 0.1,
          }}
        >
          {breadcrumbs.map((item, index) => (
            <SwiperSlide key={index} className={styles.slide}>
              <BreadcrumbsItem
                label={item.label}
                url={item.url}
                first={index === 0}
                last={index === breadcrumbs.length - 1}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <JsonLd item={jsonLdItems} type="breadcrumbs" />
    </>
  )
}

export default Breadcrumbs
